<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul>
          <li>
            Intranet del Colaborador
          </li>
        </ul>
      </nav>
      <div class="copyright d-flex flex-wrap">
        &copy;
        <a href="https://www.jlaasociados.es" target="_blank">JLA Asociados, Correduría de Seguros S.A.</a>&nbsp;
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
</style>
